import React from "react";

export default function MicPermissionPrompt({ onReload }) {
  return (
    <div
      style={{
        backgroundColor: "#fdecea",
        color: "#611a15",
        border: "1px solid #f5c6cb",
        borderRadius: "6px",
        padding: "10px",
        marginTop: "12px",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: "13px", marginBottom: "8px" }}>
        Microphone permission is blocked. Please allow mic access to continue.
      </div>
      <button
        onClick={onReload || (() => window.location.reload())}
        style={{
          backgroundColor: "#996cfe",
          color: "white",
          border: "none",
          borderRadius: "4px",
          padding: "6px 10px",
          cursor: "pointer",
        }}
      >
        Reload and allow microphone
      </button>
    </div>
  );
}


